import { segmentAnalyticsInstance } from "@/domains/metrics/segment-analytics-instance";
import {
  clearMetricsGoogleAnalyticsClientId,
  clearMetricsGoogleAnalyticsSessionId,
} from "@/modules/metrics/google-analytics";
import {
  clearGoogleAnalyticsClientIdCookie,
  clearGoogleAnalyticsSessionIdCookies,
} from "@/modules/metrics/google-analytics.utils";
import { clearMetricsMetadataString } from "@/modules/metrics/metadata";
import { clearMetricsSegmentAnonymousId } from "@/modules/metrics/segment";
import { clearMetricsElectronAppInfo } from "@/modules/metrics/electron-app-info";

export const resetPersistentTrackingData = async () => {
  /**
   * We reset the Segment analytics instance, which will
   * issue a new anonymous ID for the user.
   */
  await segmentAnalyticsInstance().reset();

  /**
   * We also clear out the GA client id cookie and all GA4 session cookies.
   * Google will automatically re-issue new ones for the device.
   */
  await clearGoogleAnalyticsClientIdCookie();
  await clearGoogleAnalyticsSessionIdCookies();

  /**
   * We also manually clear out any stored tracking data
   * in our cache client, which will ensure that the next-set values are the
   * new ones (from above)
   */
  await Promise.all([
    clearMetricsSegmentAnonymousId(),
    clearMetricsGoogleAnalyticsClientId(),
    clearMetricsGoogleAnalyticsSessionId(),
    clearMetricsMetadataString(),
    clearMetricsElectronAppInfo(),
  ]);
};
